import React, { Component } from 'react';
import { withRouter } from 'react-router';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import update from 'immutability-helper';
import cloneDeep from 'lodash/cloneDeep';
import isEmpty from 'lodash/isEmpty';
import find from 'lodash/find';
import last from 'lodash/last';
import map from 'lodash/map';
import orderBy from 'lodash/orderBy';
import moment from 'moment';
import { Button, Panel, Table, Row, Col, Well, ButtonToolbar } from 'react-bootstrap';
import { toastr } from 'react-redux-toastr';
import { actions as toastrActions } from 'react-redux-toastr';
import ManifestsInfo from '../../analysis/components/generic/ManifestsInfo';
import ManifestTimeline from '../../../../components/ManifestTimeline/index';
import TransportMethodDropdown from '../components/TransportMethodDropdown';
import LocationDropdown from '../components/LocationDropdown';
import RunDropdown from '../components/RunDropdown';
import SpecialModalGeneric from '../components/modals/SpecialModalGeneric';
import TapModalGeneric from '../components/modals/TapModalGeneric';
import Loader from '../../../../components/Loader/index';
import Datetime from 'react-datetime';
import RowButtons from '../components/RowButtons';
import CommentBox from '../components/modals/CommentBox';
import ConfirmationModal from '../components/modals/ConfirmationModal';
import FieldGroup from '../../../../components/FieldGroup';
import { TRANSPORT_METHODS, RECOVERY_ACTIONS } from '../../../../constants';
import { formatDateTime, formatDate } from '../../../../shared/utils/date';
import { formatSupplier } from '../../../../shared/utils/run';
import {
    getAbnormalityAnalysis,
    postUnrelatedManifestsAnalysis,
    getJourneyBuilderAnalysisData,
} from '../../analysisDuck';
import { get, post } from '../../../../shared/http/request';
import { handleApiError } from '../../../../shared/http/error';
import { goBackOneSegment, goBackTwoSegments } from '../../../../shared/utils/url';
import { createJourneyBuilderBreadcrumb } from '../../../../shared/utils/breadcrumbs';
import { isManifestBased } from '../../../../shared/utils/abnormalityHelpers';
import './JourneyBuilder.css';

const defaultJourneyRow = {
    transportMethod: '',
    comment: '',
    from: {},
    to: {},
    run: {},
    hasTap: false,
};
const defaultJourneyListDataRow = { fromList: [], toList: [], runsList: [] };
const JOURNEY_CONFIRMATION = 'JOURNEY_CONFIRMATION';

class JourneyBuilder extends Component {
    state = {
        journeyData: [defaultJourneyRow],
        journeyListData: [defaultJourneyListDataRow],
        fromList: [],
        toList: [],
        runsList: [],
        modal: {
            showSpecialModal: false,
            showTapModal: false,
            showConfirmationModal: false,
        },
        abnormalityManifests: [],
        abnormalityManifestGroup: {},
        manifestIds: [],
        manifestHasTimelines: false,
        journeyConfirmationData: {},
        isDisabled: false,
        isDismissDisabled: false,
    };

    componentWillReceiveProps(nextProps) {
        const { isEmaSma } = this.props.journeyBuilderAnalysisData;
        const { manifestIds } = this.state;

        if (manifestIds && this.props.abnormalityAnalysis !== nextProps.abnormalityAnalysis) {
            // Find the manifestGroup that contains the (emaSma)manifests
            const abnormalityManifestGroup = nextProps.abnormalityAnalysis.manifestGroups.filter(
                manGroup =>
                    manGroup.manifests.some(
                        manifest =>
                            manifestIds.indexOf(
                                isEmaSma && manifest.manifest.emaSmaManifest
                                    ? manifest.manifest.emaSmaManifest.emaSmaManifestId
                                    : manifest.manifest.manifestId
                            ) > -1
                    )
            );
            if (abnormalityManifestGroup.length > 0) {
                // Filter out the abnormality manifest from that group
                const abnormalityManifests = abnormalityManifestGroup[0].manifests.filter(
                    abnormalityManifest =>
                        manifestIds.indexOf(
                            isEmaSma && abnormalityManifest.manifest.emaSmaManifest
                                ? abnormalityManifest.manifest.emaSmaManifest.emaSmaManifestId
                                : abnormalityManifest.manifest.manifestId
                        ) > -1
                );
                this.setState(() => ({
                    abnormalityManifestGroup,
                    abnormalityManifests,
                }));
            } else {
                toastr.info(
                    'Unable to find the selected manifest(s) in the list of abnormality manifests...'
                );
            }
        }
    }

    componentDidMount() {
        const { abnormalityId, manifests, isEmaSma } = this.props.journeyBuilderAnalysisData;
        const manifestIds = map(manifests, m => (isEmaSma ? m.emaSmaManifestId : m.manifestId));
        // Instead of getting an analysis for an abnormality, get the analysis specifically for the manifests...
        // This way regular abnormality analysis and unrelated manifest analysis are both covered.
        this.props.postUnrelatedManifestsAnalysis(abnormalityId, {
            manifestIds,
        });
        this.setState({ manifestIds: manifestIds });

        // Check only the first manifest, they all follow the same journey...
        get(`api/manifests/${manifestIds[0]}/hasTimeLines`).then(
            res => this.setState({ manifestHasTimelines: res.hasTimeLine }),
            err => this.props.toastr.error('Could not determine timeline availability...')
        );
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevState.abnormalityManifests !== this.state.abnormalityManifests) {
            this.setTimelineAbnormality(prevProps);
        }
        if (this.lastRowHasChanged(prevState) && this.fromAndToLocationAreChosen()) {
            this.setRunInState(this.state.journeyData.length - 1, {});
            this.setRunList();
        }
    }

    setRunList() {
        const { manifestIds } = this.state;
        const { collectionManifestId } = this.props.journeyBuilderAnalysisData;
        const impactedRunManifestId = collectionManifestId ? collectionManifestId : manifestIds[0];
        const isPlannedLog = last(this.state.journeyData).transportMethod === 'PLANNED_LOGISTICS';

        this.props.toastr.add({
            id: 'fetchingRuns',
            type: 'info',
            title: 'Fetching runs',
            position: 'top-right',
            attention: true,
            message: '',
            options: {},
        });

        post(
            `/api/abnormality/manifests/${impactedRunManifestId}/run-selector?onlyPlannedRuns=${isPlannedLog}`,
            {
                from: last(this.state.journeyData).from,
                to: last(this.state.journeyData).to,
            }
        ).then(
            res => {
                const journeyListData = update(this.state.journeyListData, {
                    [this.state.journeyData.length - 1]: {
                        runsList: { $set: res.runs },
                    },
                });
                this.setState(() => ({
                    journeyListData,
                }));
                this.props.toastr.remove('fetchingRuns');
            },
            err => this.props.toastr.remove('fetchingRuns')
        );
    }

    lastRowHasChanged(prevState) {
        return (
            last(prevState.journeyData).from.stopId !== last(this.state.journeyData).from.stopId ||
            last(prevState.journeyData).to.stopId !== last(this.state.journeyData).to.stopId ||
            last(prevState.journeyData).transportMethod !==
                last(this.state.journeyData).transportMethod
        );
    }

    fromAndToLocationAreChosen() {
        return (
            last(this.state.journeyData).from &&
            last(this.state.journeyData).to &&
            Object.keys(last(this.state.journeyData).from).length > 0 &&
            Object.keys(last(this.state.journeyData).to).length > 0
        );
    }

    setTimelineAbnormality(prevProps) {
        const { collectionRunId } = this.props.journeyBuilderAnalysisData;

        if (collectionRunId) {
            // If collectionRunId present, the timeline has been changed in analysis.
            // Need to get timelineInfo with collectionRunId
            post('/api/abnormality/manifests/collection-timelines', {
                collectionRunId: collectionRunId,
                emcDockCode: this.state.abnormalityManifests[0].manifest.emcDockCode,
                supplierCode: this.state.abnormalityManifests[0].manifest.supplierCode,
                supplierPlantCode: this.state.abnormalityManifests[0].manifest.supplierPlantCode,
            }).then(res => {
                this.setState(() => ({
                    plannedRun: res.plannedRun,
                    previousRun: res.previousRun,
                    nextRun: res.nextRun,
                }));
            });
        } else {
            // Use timeline info from abnormalityManifestGroup
            this.setState(state => ({
                plannedRun: state.abnormalityManifestGroup[0].plannedRun,
                previousRun: state.abnormalityManifestGroup[0].previousRun,
                nextRun: state.abnormalityManifestGroup[0].nextRun,
            }));
        }
    }

    handleTransportMethodChange = (transportMethod, index) => {
        const journeyData = update(this.state.journeyData, {
            [index]: { transportMethod: { $set: transportMethod } },
        });
        const journeyListData = update(this.state.journeyListData, {
            [index]: { fromList: { $set: [] }, toList: { $set: [] } },
        });
        this.setState(() => ({
            journeyData,
            journeyListData,
        }));
        if (transportMethod === TRANSPORT_METHODS.SPECIAL) {
            this.toggleModal(RECOVERY_ACTIONS.SPECIAL);
        } else {
            this.getStopLists(index);
        }
    };

    getStopLists(index) {
        const { manifestIds } = this.state;
        const { collectionManifestId } = this.props.journeyBuilderAnalysisData;
        const stopsManifestIds = collectionManifestId !== '' ? [collectionManifestId] : manifestIds;

        this.props.toastr.add({
            id: 'fetchingStops',
            type: 'info',
            title: 'Fetching stops',
            position: 'top-right',
            attention: true,
            message: '',
            options: {},
        });

        post(`/api/abnormality/manifests/stops`, {
            manifestIds: stopsManifestIds,
        }).then(
            res => {
                const journeyListData = update(this.state.journeyListData, {
                    [index]: {
                        fromList: {
                            $set: orderBy(res.fromStops, ['stopCode'], ['asc']),
                        },
                        toList: {
                            $set: orderBy(res.toStops, ['stopCode'], ['asc']),
                        },
                    },
                });

                this.setState(() => ({
                    journeyListData,
                }));
                this.props.toastr.remove('fetchingStops');
            },
            err => this.props.toastr.remove('fetchingStops')
        );
    }

    handleFromLocationChange = (fromLocationId, index) => {
        const fromLocation = this.state.journeyListData[index].fromList.find(
            from => from.stopId === fromLocationId
        );
        const journeyData = update(this.state.journeyData, {
            [index]: { from: { $set: fromLocation }, run: { $set: {} } },
        });
        this.setState(() => ({
            journeyData,
        }));
    };

    handleToLocationChange = (toLocationId, index) => {
        const toLocation = this.state.journeyListData[index].toList.find(
            to => to.stopId === toLocationId
        );
        const journeyData = update(this.state.journeyData, {
            [index]: { to: { $set: toLocation }, run: { $set: {} } },
        });
        this.setState(() => ({
            journeyData,
        }));
    };

    handleRunChange = (runId, index) => {
        const run = this.state.journeyListData[index].runsList.find(run => run.runId === runId);
        this.setRunInState(index, run);

        if (this.state.journeyData[index].transportMethod === TRANSPORT_METHODS.PLANNED_LOGISTICS) {
            this.toggleModal(RECOVERY_ACTIONS.TAP);
        }
    };

    setRunInState(index, run) {
        const journeyData = update(this.state.journeyData, {
            [index]: { run: { $set: run } },
        });
        this.setState(() => ({
            journeyData,
        }));
    }

    handleDateChange = name => date => {
        const journeyData = update(this.state.journeyData, {
            [name]: { dueDate: { $set: date.format('DD-MM-YYYY HH:mm') } },
        });
        this.setState(() => ({
            journeyData,
        }));
    };

    handleCommentChange = index => e => {
        const journeyData = update(this.state.journeyData, {
            [index]: { comment: { $set: e.target.value } },
        });
        this.setState(() => ({
            journeyData,
        }));
    };

    handleSpecialCreate = specialData => {
        console.log('Special data', specialData);
        const journeyData = update(this.state.journeyData, {
            [this.state.journeyData.length - 1]: { $set: specialData },
        });
        this.setState(() => ({
            journeyData,
        }));
        this.toggleModal(RECOVERY_ACTIONS.SPECIAL);
    };

    handleTapCreate = tapData => {
        console.log('Tap data', tapData);
        const lastRowIndex = this.state.journeyData.length - 1;
        // When adding tap info for a Planned Logistics, it needs to be false...
        const hasTap = !this.isPlannedLogistics(lastRowIndex);

        let clonedJourneyData = cloneDeep(this.state.journeyData[lastRowIndex]);

        clonedJourneyData = Object.assign({}, clonedJourneyData, tapData, {
            hasTap: hasTap,
            dueDate: moment(tapData.tapInfo.tapDueDate).format('DD-MM-YYYY HH:mm'),
        });

        const journeyData = update(this.state.journeyData, {
            [lastRowIndex]: {
                $set: clonedJourneyData,
            },
        });
        this.setState({ journeyData });
        this.toggleModal(RECOVERY_ACTIONS.TAP);
    };

    addJourneyRow = () => {
        const journeyData = update(this.state.journeyData, {
            $push: [defaultJourneyRow],
        });
        const journeyListData = update(this.state.journeyListData, {
            $push: [defaultJourneyListDataRow],
        });
        this.setState(() => ({
            journeyData,
            journeyListData,
        }));
    };

    removeJourneyRow = () => {
        this.setState(() => ({
            journeyData: this.state.journeyData.slice(0, -1),
            journeyListData: this.state.journeyListData.slice(0, -1),
        }));
    };

    rowIsLast(index) {
        return index === this.state.journeyData.length - 1;
    }

    isSpecial(index) {
        return this.state.journeyData[index].transportMethod === TRANSPORT_METHODS.SPECIAL;
    }

    isPlannedLogistics(index) {
        return (
            this.state.journeyData[index].transportMethod === TRANSPORT_METHODS.PLANNED_LOGISTICS
        );
    }

    toggleModal = type => {
        const { modal } = this.state;

        switch (type) {
            case RECOVERY_ACTIONS.SPECIAL:
                this.setState({
                    modal: {
                        ...modal,
                        showSpecialModal: !this.state.modal.showSpecialModal,
                    },
                });
                break;
            case RECOVERY_ACTIONS.TAP:
                this.setState({
                    modal: {
                        ...modal,
                        showTapModal: !this.state.modal.showTapModal,
                    },
                });
                break;
            case JOURNEY_CONFIRMATION:
                this.setState({
                    modal: {
                        ...modal,
                        showConfirmationModal: !this.state.modal.showConfirmationModal,
                    },
                });
                break;
            default:
                break;
        }
    };

    tryJourney = () => {
        const journey = this.transformJourneyDataBeforePost();

        post(`/api/command/tryCreateGenericJourneyCommand`, journey).then(
            journeyConfirmationData => {
                this.setState({ journeyConfirmationData });
                this.toggleModal(JOURNEY_CONFIRMATION);
            },
            error => {
                handleApiError(error, this.props.dispatch);
            }
        );
    };

    confirmJourney = () => {
        const journey = this.transformJourneyDataBeforePost();

        post(`/api/command/createGenericJourneyCommand`, journey).then(
            () => {
                toastr.success('Recovery action(s) created. Redirecting back to abnormality...');
                setTimeout(() => {
                    goBackTwoSegments(this.props.location, this.props.router);
                }, 1500);
                this.toggleModal(JOURNEY_CONFIRMATION);
            },
            error => {
                handleApiError(error, this.props.dispatch);
            }
        );
        this.setState({isDisabled:true})
        this.setState({isDismissDisabled:true})
    };

    transformJourneyDataBeforePost() {
        const { abnormalityId, isEmaSma } = this.props.journeyBuilderAnalysisData;
        const { abnormalityManifests, manifestIds, journeyData } = this.state;

        let clonedJourneyData = cloneDeep(journeyData);
        clonedJourneyData = this.processRunBeforeSubmit(clonedJourneyData);
        clonedJourneyData = this.processDatesBeforeSubmit(clonedJourneyData);

        return {
            abnormalityId: abnormalityId,
            manifests: this.processManifestsBeforeSubmit(
                abnormalityManifests,
                manifestIds,
                isEmaSma
            ),
            recoveryActions: clonedJourneyData,
        };
    }

    processManifestsBeforeSubmit = (abnormalityManifests, manifestIds, isEmaSma) => {
        // Add the abnormalityManifestId next to the manifestId for each manifest
        let manifestTuples = [];

        manifestIds.forEach(id => {
            const abnormalityManifest = find(abnormalityManifests, ['manifest.manifestId', id]);

            if (!isEmpty(abnormalityManifest)) {
                manifestTuples.push({
                    manifestId: id,
                    abnormalityManifestId: abnormalityManifest.abnormalityManifestId,
                });
            } else {
                console.log(
                    `[JourneyBuilder] Could not find abnormalityManifestId for manifest ${id}`
                );
            }
        });

        return manifestTuples;
    };

    processRunBeforeSubmit = clonedJourneyData => {
        return clonedJourneyData.map(recAction => {
            recAction.runId = recAction.run ? recAction.run.runId : null;
            delete recAction.run;
            return recAction;
        });
    };

    processDatesBeforeSubmit = clonedJourneyData => {
        return clonedJourneyData.map(recAction => {
            recAction.dueDate = moment(recAction.dueDate, 'DD-MM-YYYY HH:mm').toISOString();
            return recAction;
        });
    };

    redirectToAnalysis = () => {
        goBackOneSegment(this.props.location, this.props.router);
    };

    renderCollectionInfo = () => {
        const {
            abnormalityAnalysis,
            journeyBuilderAnalysisData: {
                collectionRoute,
                collectionDate,
                collectionSupplier,
                collectionEmcDock,
            },
        } = this.props;
        const manifest = abnormalityAnalysis.manifestGroups[0]
            ? abnormalityAnalysis.manifestGroups[0].manifests[0].manifest
            : {};
        let data = {
            collectionRoute: '-',
            collectionDate: '-',
            collectionSupplier: '-',
            collectionEmcDock: '-',
        };

        if (collectionRoute) {
            data.collectionRoute = collectionRoute;
            data.collectionDate = collectionDate;
            data.collectionSupplier = collectionSupplier;
            data.collectionEmcDock = collectionEmcDock;
        } else if (abnormalityAnalysis) {
            data.collectionRoute = abnormalityAnalysis.routeCode
                ? `${abnormalityAnalysis.routeCode} - ${formatDate(
                      abnormalityAnalysis.runDate
                  )} - ${abnormalityAnalysis.runSequence}`
                : '-';
            data.collectionDate = abnormalityAnalysis.runDate;
            data.collectionSupplier =
                formatSupplier({
                    supplierCode: manifest.supplierCode,
                    supplierPlantCode: manifest.supplierPlantCode,
                }) || '-';
            data.collectionEmcDock = manifest.emcDockCode || '-';
        }

        return (
            <Well>
                <Row>
                    <Col sm={6}>
                        <FieldGroup
                            id="collectionRoute"
                            label={'Collection Route'}
                            value={data.collectionRoute}
                            horizontal={true}
                            readOnly={true}
                            noBottomMargin
                        />
                    </Col>
                    <Col sm={6}>
                        <FieldGroup
                            id="collectionDate"
                            label={'Collection Date'}
                            value={formatDate(data.collectionDate)}
                            horizontal={true}
                            readOnly={true}
                            noBottomMargin={true}
                        />
                    </Col>
                </Row>
            </Well>
        );
    };

    render() {
        const { abnormalityAnalysis, journeyBuilderAnalysisData } = this.props;
        const {
            abnormalityManifests,
            plannedRun,
            previousRun,
            nextRun,
            journeyData,
            journeyListData,
            modal,
            journeyConfirmationData,
            manifestHasTimelines,
        } = this.state;

        if (isEmpty(abnormalityManifests)) {
            return <Loader />;
        }

        return (
            <div>
                {abnormalityAnalysis &&
                    createJourneyBuilderBreadcrumb(
                        abnormalityAnalysis,
                        abnormalityManifests[0],
                        isManifestBased(abnormalityAnalysis.genericAbnormalityType)
                    )}
                <ManifestsInfo
                    selectable={false}
                    manifests={abnormalityManifests ? abnormalityManifests : []}
                    showEmaButtons={false}
                />
                <div>{this.renderCollectionInfo()}</div>
                <Panel>
                    <ManifestTimeline
                        plannedRun={plannedRun}
                        previousRun={previousRun}
                        nextRun={nextRun}
                    />
                </Panel>
                <Table striped bordered condensed hover>
                    <thead className="journey-builder-head">
                        <tr>
                            <th>Transport Method *</th>
                            <th>From *</th>
                            <th>To *</th>
                            <th>Run *</th>
                            <th>
                                Due Date{' '}
                                {this.isPlannedLogistics(journeyData.length - 1) ? '' : '*'}
                            </th>
                            <th>Tap</th>
                            <th>Tap Date</th>
                            <th>Comment</th>
                            <th />
                        </tr>
                    </thead>
                    <tbody className="journey-builder-body">
                        {journeyData.map((row, index) => (
                            <tr key={index}>
                                <td>
                                    <TransportMethodDropdown
                                        manifestHasTimelines={manifestHasTimelines}
                                        isEmaSmaManifest={journeyBuilderAnalysisData.isEmaSma}
                                        disabled={!this.rowIsLast(index)}
                                        transportMethod={journeyData[index].transportMethod}
                                        handleChange={this.handleTransportMethodChange}
                                        rowNumber={index}
                                    />
                                </td>
                                <td>
                                    <LocationDropdown
                                        location={journeyData[index].from}
                                        isSpecial={this.isSpecial(index)}
                                        list={journeyListData[index].fromList}
                                        selectedLocationId={
                                            journeyData[index].from
                                                ? journeyData[index].from.stopId
                                                : ''
                                        }
                                        handleChange={this.handleFromLocationChange}
                                        disabled={!this.rowIsLast(index) || this.isSpecial(index)}
                                        rowNumber={index}
                                    />
                                </td>
                                <td>
                                    <LocationDropdown
                                        location={journeyData[index].to}
                                        isSpecial={this.isSpecial(index)}
                                        list={journeyListData[index].toList}
                                        selectedLocationId={
                                            journeyData[index].to
                                                ? journeyData[index].to.stopId
                                                : ''
                                        }
                                        handleChange={this.handleToLocationChange}
                                        disabled={!this.rowIsLast(index)}
                                        rowNumber={index}
                                    />
                                </td>
                                <td>
                                    <RunDropdown
                                        impactedRuns={
                                            this.isSpecial(index) && journeyData[index].specialInfo
                                                ? journeyData[index].specialInfo.impactedRuns
                                                : []
                                        }
                                        isSpecial={this.isSpecial(index)}
                                        list={journeyListData[index].runsList}
                                        selectedRunId={
                                            journeyData[index].run && journeyData[index].run.runId
                                        }
                                        handleChange={this.handleRunChange}
                                        disabled={!this.rowIsLast(index)}
                                        rowNumber={index}
                                    />
                                </td>
                                <td className="vert-center">
                                    {!this.isPlannedLogistics(index) && (
                                        <Datetime
                                            value={journeyData[index].dueDate}
                                            onChange={this.handleDateChange(index)}
                                            dateFormat="DD-MM-YYYY"
                                            timeFormat="HH:mm"
                                            inputProps={{
                                                maxLength: 255,
                                                disabled: !this.rowIsLast(index),
                                            }}
                                            closeOnSelect
                                        />
                                    )}
                                    {this.isPlannedLogistics(index) && 'N/A'}
                                </td>
                                <td>
                                    <Button
                                        onClick={() => this.toggleModal(RECOVERY_ACTIONS.TAP)}
                                        disabled={this.isSpecial(index)}
                                    >
                                        Tap
                                    </Button>
                                </td>
                                <td className="padded-top">
                                    {journeyData[index].tapInfo &&
                                    journeyData[index].tapInfo.tapDate
                                        ? formatDateTime(journeyData[index].tapInfo.tapDate)
                                        : ''}
                                </td>
                                <td>
                                    <CommentBox
                                        rowIsLast={this.rowIsLast(index)}
                                        value={journeyData[index].comment}
                                        handleChange={this.handleCommentChange(index)}
                                        index={index}
                                    />
                                </td>
                                <td>
                                    <RowButtons
                                        handleAddRow={this.addJourneyRow}
                                        handleRemoveRow={this.removeJourneyRow}
                                        index={index}
                                        isLastRow={this.rowIsLast(index)}
                                    />
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </Table>
                <ButtonToolbar className="pull-right">
                    <Button onClick={this.redirectToAnalysis}>Cancel</Button>
                    <Button bsStyle="success" onClick={this.tryJourney}>
                        Create journey
                    </Button>
                </ButtonToolbar>

                <SpecialModalGeneric
                    abnormalityManifest={abnormalityManifests[0]}
                    runDate={abnormalityAnalysis.runDate}
                    handleSpecialCreate={this.handleSpecialCreate}
                    showModal={modal.showSpecialModal}
                    isEmaSmaManifest={journeyBuilderAnalysisData.isEmaSma}
                    collectionManifestId={journeyBuilderAnalysisData.collectionManifestId}
                    onClose={() => this.toggleModal(RECOVERY_ACTIONS.SPECIAL)}
                />
                <TapModalGeneric
                    runDate={abnormalityAnalysis.runDate}
                    handleTapCreate={this.handleTapCreate}
                    showModal={modal.showTapModal}
                    onClose={() => this.toggleModal(RECOVERY_ACTIONS.TAP)}
                />
                <ConfirmationModal
                    journeyConfirmationData={journeyConfirmationData}
                    onClose={() => this.toggleModal(JOURNEY_CONFIRMATION)}
                    onConfirm={this.confirmJourney}
                    showModal={modal.showConfirmationModal}
                    isDisabled={this.state.isDisabled}
                    isDismissDisabled={this.state.isDismissDisabled}
                />
            </div>
        );
    }
}

export default withRouter(
    connect(
        (state, props) => ({
            abnormalityAnalysis: getAbnormalityAnalysis(state, props.params.abnormalityId),
            journeyBuilderAnalysisData: getJourneyBuilderAnalysisData(state),
        }),
        dispatch => ({
            postUnrelatedManifestsAnalysis: bindActionCreators(
                postUnrelatedManifestsAnalysis,
                dispatch
            ),
            toastr: bindActionCreators(toastrActions, dispatch),
        })
    )(JourneyBuilder)
);
